import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { SubscriptionModule } from '@fantaz/shared/ui/subscribe';
import { TournamentControlsComponent } from './tournament-controls.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    CurrencyModule,
    SubscriptionModule,
    MatTooltipModule,
    SharedPipesDateModule,
  ],
  declarations: [TournamentControlsComponent],
  exports: [TournamentControlsComponent],
})
export class TournamentControlsModule {}
